// extracted by mini-css-extract-plugin
module.exports = {"nav_section":"navbar_nav_section__jYkal","right_section":"navbar_right_section__2ncwQ"};